import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { RoleSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { RolesContainer } from "@/screens/SystemAdmin/containers"

const SearchParamsValidator = z.object({
  field: fallback(z.nativeEnum(RoleSortField), RoleSortField.Role),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
})

export const Route = createFileRoute("/app/admin/system-admin/_layout/roles")({
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams(["field", "order"])],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.ROLE_MAINTENANCE]}>
      <RolesContainer />
    </PermissionContentWrapper>
  ),
})
